import Axios from 'axios'

const doctor = {
  axios () {
    let AxiosInstance = Axios
    AxiosInstance.defaults.baseURL = process.env.BACKEND_URL
    return AxiosInstance
  },
  createDoctor (data) {
    return this.axios().post('/doctor', data)
  },
  getDoctors () {
    return this.axios().get('/doctor')
  },
  editDoctor (data) {
    return this.axios().put('/doctor', data)
  },
  deleteDoctor (id) {
    return this.axios().delete('/doctor/' + id)
  },
  getDoctorByCrmAndUf (crm, uf) {
    return this.axios().get('/doctor/crm/' + crm + '/uf/' + uf)
  },
  getDoctorHelthBodiesByCrmAndUf (crm, uf) {
    return this.axios().get(`doctor/${crm}/${uf}`, {
      baseURL: process.env.RESULTS_PDF,
    })
  },
  getDoctorById (id) {
    return this.axios().get('/doctor/' + id)
  }
}

export default doctor
